(<template>
  <article class="chat-reject">
    <div v-if="userIsInterpreter"
         class="chat-reject__content">
      <p class="chat-reject__text">{{ interpreterRejectText }}</p>
    </div>
    <div v-else
         class="chat-reject__content">
      <p class="chat-reject__text">{{ businessRejectText }}</p>
    </div>
  </article>
</template>)

<script>
  import {mapGetters} from 'vuex';

  export default {
    props: {
      eventData: {
        type: Object,
        default() {
          return {};
        }
      },
      fullData: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    computed: {
      ...mapGetters({
        userIsInterpreter: 'UserInfoStore/userIsInterpreter'
      }),
      businessRejectText() {
        return this.$gettext('This interpreters offer has been rejected.');
      },
      interpreterRejectText() {
        const template = this.$gettext('Your offer has been rejected.');
        return this.$gettextInterpolate(template, {n: this.fullData && this.fullData.demanderInfo ? this.fullData.demanderInfo.name : ''});
      }
    }
  };
</script>

<style scoped>
  .chat-reject__text {
    margin-bottom: 5px;
    color: #f04;
    color: var(--color-error);
    font-size: 14px;
  }
</style>
